import moment from "moment";
import { deepGet } from '../api/Utils';

export function getDateRange(data: any, path: Array<string>, startDate: any, endDate: any, format: string) {
  let filterStartDate = moment(startDate).format(format);
  let filterEndDate = moment(endDate).format(format);
  return data.filter((item: any) =>
    moment(moment(deepGet(item, [...path])).format(format)).isBetween(filterStartDate, filterEndDate, null, '[]')
  );
}